import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=4303666e&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=4303666e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4303666e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4303666e')) {
      api.createRecord('4303666e', component.options)
    } else {
      api.reload('4303666e', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=4303666e&scoped=true", function () {
      api.rerender('4303666e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/header/PageHeader.vue"
export default component.exports